<template>
  <div class="px-3 py-2.5">
    <slot />
  </div>
</template>
